import { render, staticRenderFns } from "./renzhenginfo.vue?vue&type=template&id=8c53a69e&scoped=true&"
import script from "./renzhenginfo.vue?vue&type=script&lang=js&"
export * from "./renzhenginfo.vue?vue&type=script&lang=js&"
import style0 from "./renzhenginfo.vue?vue&type=style&index=0&id=8c53a69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53a69e",
  null
  
)

export default component.exports